import React, { useState } from 'react';
import {
  Dialog,
  DialogContent,
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Slide,
  Box,
  Card,
  CardContent,
  Tabs,
  Tab,
  Button,
  Tooltip,
} from '@mui/material';
import { Close, Edit as EditIcon } from '@mui/icons-material';

import OverviewTab from './FullScreenGoalDataParts/OverviewTab';
import DetailsTab from './FullScreenGoalDataParts/DetailsTab';
import MeasurementTab from './FullScreenGoalDataParts/MeasurementTab';
import SubgoalsTab from './FullScreenGoalDataParts/SubgoalsTab';
import TaskAnalysisTab from './FullScreenGoalDataParts/TaskAnalysisTab';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction='up' ref={ref} {...props} />;
});

const FullScreenGoalDetailsView = ({
  open,
  onClose,
  teachersForStudent,
  goalData,
  goals,
}) => {
  const [activeTab, setActiveTab] = useState(0);

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  return (
    <Dialog
      fullScreen
      open={open}
      onClose={onClose}
      TransitionComponent={Transition}
    >
      <AppBar
        sx={{
          position: 'relative',
          bgcolor: '#9291ef',
          boxShadow: '0 2px 4px rgba(146, 145, 239, 0.2)',
        }}
      >
        <Toolbar>
          <IconButton
            edge='start'
            color='inherit'
            onClick={onClose}
            aria-label='close'
            sx={{ '&:hover': { bgcolor: 'rgba(255,255,255,0.1)' } }}
          >
            <Close />
          </IconButton>
          <Typography
            sx={{ ml: 2, flex: 1, fontWeight: 700, letterSpacing: '0.5px' }}
            variant='h6'
            component='div'
          >
            Goal Details
          </Typography>
        </Toolbar>
      </AppBar>

      <DialogContent sx={{ p: 0, bgcolor: '#fafbfc' }}>
        <Box sx={{ height: '100%', overflow: 'auto' }}>
          <Card
            elevation={0}
            sx={{
              width: '100%',
              backgroundColor: 'white',
              borderRadius: 0,
              minHeight: '100vh',
              boxShadow: 'none',
            }}
          >
            <Box
              sx={{
                borderBottom: '1px solid #f0f0f0',
                px: 4,
                pt: 2,
                backgroundColor: 'white',
              }}
            >
              <Tabs
                value={activeTab}
                onChange={handleTabChange}
                aria-label='goal data tabs'
                centered
                sx={{
                  '& .MuiTabs-indicator': {
                    backgroundColor: '#9291ef',
                    height: 3,
                    borderRadius: '2px',
                  },
                  '& .MuiTab-root': {
                    color: '#6c757d',
                    fontWeight: 500,
                    fontSize: '0.95rem',
                    textTransform: 'none',
                    minHeight: 56,
                    px: 3,
                    '&:hover': {
                      color: '#9291ef',
                      backgroundColor: 'rgba(146, 145, 239, 0.04)',
                    },
                  },
                  '& .Mui-selected': {
                    color: '#9291ef !important',
                    fontWeight: 600,
                  },
                }}
              >
                <Tab label='Overview' />
                <Tab label='Details' />
                <Tab label='Measurement' />
                {goalData?.HasSubgoal?.HasSubgoal === 'Yes' && (
                  <Tab label='Subgoals' />
                )}
                {goalData?.TaskAnalysis?.HasTaskAnalysis === 'Yes' && (
                  <Tab label='Task Analysis' />
                )}
              </Tabs>
            </Box>

            <CardContent
              sx={{ p: 5, backgroundColor: '#fafbfc', minHeight: '400px' }}
            >
              {activeTab === 0 && (
                <OverviewTab
                  goalData={goalData}
                  teachersForStudent={teachersForStudent}
                />
              )}
              {activeTab === 1 && <DetailsTab goalData={goalData} />}
              {activeTab === 2 && <MeasurementTab goalData={goalData} />}
              {activeTab === 3 &&
                goalData?.HasSubgoal?.HasSubgoal === 'Yes' && (
                  <SubgoalsTab goalData={goalData} />
                )}
              {activeTab === 4 &&
                goalData?.TaskAnalysis?.HasTaskAnalysis === 'Yes' && (
                  <TaskAnalysisTab goalData={goalData} />
                )}
            </CardContent>
          </Card>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default FullScreenGoalDetailsView;
